module.exports = __webpack_public_path__ + "static/img/geokrishi.ed28cef5.png";